import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            焦点专题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            精选深度专题内容，全方位解读黑料背后的故事
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {carouselItems.map((item, idx) => (
            <div
              key={idx}
              className="group relative rounded-xl overflow-hidden cursor-pointer h-[280px] md:h-[320px]"
            >
              <img
                src={item.img}
                alt={item.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                onError={(e) => {
                  (e.currentTarget as HTMLImageElement).style.display = 'none';
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-black/10"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="inline-block px-2 py-1 bg-accent-500 text-background-50 text-xs font-medium rounded mb-2 whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="text-base md:text-lg font-heading text-white mb-1.5">{item.title}</h3>
                <p className="text-white/70 text-xs md:text-sm leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}